
import * as Tooltip from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';

interface CustomTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delayDuration?: number;
}

export default function CustomTooltip({ children, content, side = 'top', delayDuration = 100 }: CustomTooltipProps) {
  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            className={cn(
              'bg-white text-gray-900 text-sm px-3 py-2 rounded-md shadow-md border border-gray-300',
              'duration-100 ease-in-out opacity-100 z-50'
            )}
          >
            {content}
            <Tooltip.Arrow className="fill-white stroke-gray-300 stroke-2" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
